import { render, staticRenderFns } from "./movies.vue?vue&type=template&id=8c48c6a8"
import script from "./movies.vue?vue&type=script&lang=js"
export * from "./movies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports